import React, { Fragment } from 'react'
import QuantityChanger from '../Components/QuantityChanger'

const MiniCartOrderRow = ({
    orderRow,
    removeOrderRow,
    updateOrderRowQuantity,
}) => {
    const getPriceSegment = (orderRow) => {
        if (orderRow.campaignPrice) {
            return (
                <Fragment>
                    {orderRow.campaignPrice}
                    <span className="cart__info-row-details-price--old-price">
                        {orderRow.price}
                    </span>
                </Fragment>
            )
        }
        return orderRow.price
    }

    return (
        <div className="cart__info-row">
            <a className="cart__info-row-link" href={orderRow.url}>
                <img className="cart__info-row-image" src={orderRow.image} />
            </a>
            <div className="cart__info-row-details">
                <a className="cart__info-row-details-link" href={orderRow.url}>
                    {orderRow.name}
                </a>
                <button
                    onClick={() => removeOrderRow(orderRow.rowSystemId)}
                    className="cart__info-row-delete fa fa-trash-o"
                ></button>
                <div className="cart__info-row-details-price">
                    {getPriceSegment(orderRow)}
                </div>
                <div className="cart__info-row-details-quantity-total">
                    <div className="cart__info-row-details-quantity">
                        {orderRow.isFreeGift ? (
                            <div>{orderRow.quantity}</div>
                        ) : (
                            <QuantityChanger
                                quantity={orderRow.quantity}
                                updateQuantity={(updatedQuantity) =>
                                    updateOrderRowQuantity(
                                        orderRow.rowSystemId,
                                        updatedQuantity
                                    )
                                }
                                rowSystemId={orderRow.rowSystemId}
                            />
                        )}
                    </div>
                    <div className="cart__info-row-details-total">
                        {orderRow.totalPrice}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MiniCartOrderRow
